import React from 'react';

// Core
import type { ClientContext } from '@/client/context';
import RouterComponent from '@client/services/router/components/router';

/*----------------------------------
- COMPOSANT
----------------------------------*/
export default function App ({ context }: { 
    context: ClientContext,
 }) {

    const { Router } = context;

    return <RouterComponent service={Router} />;
}